import {
    Button,
    Icon,
    Link,
    TextField,
    Tooltip,
    Thumbnail,
    Modal,
    Pagination,
    InlineStack,
    Text,
    BlockStack,
    Badge,
    Card,
    Popover,
    Box,
    Divider,
    InlineGrid,
    Bleed
} from '@shopify/polaris';
import {
    ExternalMinor,
    SearchMinor,
} from "@shopify/polaris-icons";
import { Table } from 'antd';
import React, { useCallback, useState, useEffect, ReactElement, useContext } from 'react';
import { DI, DIProps } from '../../../../Core';
import debounce from 'lodash/debounce';
import Noimage from "../../../../../public/files/noImage.png";
import AmazonBtnIcon from "../../../../Asests/Images/amazon_icon.png";
import ShopifyBtnIcon from "../,,/../../../../Asests/Images/shopify_icon.png";
import { CloseMatchSkeleton } from '../skeleton/LinkingSkeleton';
import { ProductLinkingContext } from './utils/context/context';
import { amazon_regions } from '../../Onboarding/components/onboardinghelper';
import { isAdminLoggedIn } from '../../Panel/index';
import { ViewMoreInfo } from './utils/utils';
import { useTranslation } from 'react-i18next';
import { modifyImageUrl } from '../../Listing Grid/Utilities/Helper';
import { LazyThumbnail } from '../../Editproduct/components/Image/Image';

interface Props extends DIProps {
    viewSku?: string;
}

var timer: ReturnType<typeof setTimeout>;

/**
 * This component is responsible for the dashboard structure
 * @param props
 * @returns
 */
function CloseMatch(props: Props): ReactElement {
    const { t } = useTranslation();
    const [selectManualGridLoading, setSelectManualGridLoading] = useState(false);
    const [shopifyProducts, setShopifyProducts] = useState<any>([]);
    const [isVariant, setisVariant] = useState(false);
    const [variation, setvariation] = useState<boolean>(false)
    const [selectManualGridData2, setSelectManualGridData2] = useState([]);
    const [finalData, setFinalData] = useState({
        "_id": "",
        "source_product_id": "",
        "image-url": "",
        "seller-sku": "seller-sku"
    });

    const myContext: any = useContext(ProductLinkingContext);
    const [selectManaualModal1, setSelectManualModal1] = useState<boolean>(false);
    const [selectManualHeader1, setSelectManualHeader] = useState<any>([]);
    const [selectManaualModal2, setSelectManualModal2] = useState(false);
    const necessaryDetails = { ...myContext.necessaryDetails };

    const [inputValue, setInputValue] = useState(props.viewSku ?? "");
    const [tableLoading, setTableLoading] = useState(true);

    const [products, setProducts] = useState([]);
    const [data, setData] = useState([]);
    const [approveLoading, setApproveLoading] = useState<any>({});
    const [buttonLoading, setButtonLoading] = useState({ approveAll: false, undoApprove: false, modalButton: false });

    const [summaryOfTable, setSummaryOfTable] = useState<JSX.Element>(<></>);
    const [hasApproved, setHasApproved] = useState(false);
    const [modal, setModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(0);
    const [count, setCount] = useState(10);
    const [hasPageChanged, setHasPageChanged] = useState(false);
    const [firstRender, setfirstRender] = useState(true)

    const [showLinkModal, setshowLinkModal] = useState(false)
    const [showLinkProductsModal, setshowLinkProductsModal] = useState(false)
    const linkHeadings: any = [
        { title: <Text variant="headingSm" as="h6">{t("Image")}</Text>, dataIndex: "main_image", width: 100 },
        { title: <Text variant="headingSm" as="h6">{t("Product Title")}</Text>, dataIndex: "title", width: 200 },
        { title: <Text variant="headingSm" as="h6">{t("Shopify SKU")}</Text>, dataIndex: "sku", width: 200 },
        { title: <Text variant="headingSm" as="h6">{t("Barcode")}</Text>, dataIndex: "barcode", width: 200 },
    ];
    const [linkModalData, setlinkModalData] = useState<any[]>([])
    const [parentId, setParentId] = useState<any>("")
    const [linkProductsModalData, setlinkProductsModalData] = useState<any[]>([])
    const linkProductsHeadings: any = [
        { title: <Text variant="headingSm" as="h6">{t("Image")}</Text>, dataIndex: "main_image", width: 100 },
        { title: <Text variant="headingSm" as="h6">{t("Product Title")}</Text>, dataIndex: "titleRender", width: 200 },
        { title: <Text variant="headingSm" as="h6">{t("Shopify SKU")}</Text>, dataIndex: "sku", width: 200 },
        { title: <Text variant="headingSm" as="h6">{t("Barcode")}</Text>, dataIndex: "barcode", width: 200 },
        // { title: <Text variant="headingSm" as="h6">{t("Close Match")}</Text>, dataIndex: "closeMatch", width: 200 },
        { title: <Text variant="headingSm" as="h6">{t("Action")}</Text>, dataIndex: "action", width: 100, align: "center", },
    ];
    const [amazonData, setamazonData] = useState<any>({});
    const [selectManualLoading, setselectManualLoading] = useState(false)
    const [searchTextField, setSearchTextField] = useState('');
    const [orignalShopifyData, setOrignalShopifyData] = useState<any[]>([]);
    const [selectManualGridData1, setSelectManualGridData1] = useState([]);
    const [matchesFoundModalData, setmatchesFoundModalData] = useState<any>([])
    const [shopifySearch, setShopifySearch] = useState<any>("");
    function handleLinkModal(data: any, source_product_id: any = '', saveAmazonData = true) {
        let tempImg: any[] = [];
        if (data.closeMatchedProduct) {
            setParentId(data._id)
            data.closeMatchedProduct.filter((ele: any) => ele['source_product_id'] == source_product_id || source_product_id == '').forEach((element: any) => {
                element['main_image'] = typeof element['main_image'] == 'string' ? <>
                    {/* <img width={"60px"} height={"60px"} src={element?.['main_image'] && element?.['main_image'] != "" ? element?.['main_image'] : Noimage} /> */}
                    <LazyThumbnail
                        src={element?.['main_image'] && element?.['main_image'] != "" ? modifyImageUrl(element?.['main_image']) : Noimage}
                        alt='productImages'
                        key={element?.['main_image'] + 'Thumbnail' + Math.random()}
                        size='medium'
                        className='custom-linking-lazy__thumbnail'
                    />
                </> : element['main_image']
                tempImg.push(element)
            });
        } else {
            data['main_image'] = typeof data['main_image'] == 'string' ? <>
                {/* <img width={"60px"} height={"60px"} src={data?.['main_image'] && data?.['main_image'] != "" ? data?.['main_image'] : Noimage} /> */}
                <LazyThumbnail
                    src={data?.['main_image'] && data?.['main_image'] != "" ? modifyImageUrl(data?.['main_image']) : Noimage}
                    alt='productImages'
                    key={data?.['main_image'] + 'Thumbnail' + Math.random()}
                    size='medium'
                    className='custom-linking-lazy__thumbnail'
                />
            </> : data['main_image']
            tempImg.push(data)
        }

        setlinkModalData(tempImg)
        saveAmazonData && setamazonData(data)
        getUnmatchedShopifyProducts()
        setshowLinkProductsModal(false)
        setshowLinkModal(true);
    }

    function handleCloseLinkModal() {
        setlinkModalData([])
        setmatchesFoundModalData([]);
        setamazonData({})
        setshowLinkModal(false)
    }

    function handleMatchesFoundModal(data: any) {
        setshowLinkProductsModal(true)
        let tempImg: any[] = [];
        data.closeMatchedProduct.forEach((element: any) => {
            element['main_image'] = typeof element['main_image'] == 'string' ? <>
                {/* <img width={"60px"} height={"60px"} src={element?.['main_image'] && element?.['main_image'] != "" ? element?.['main_image'] : Noimage} /> */}
                <LazyThumbnail
                    src={element?.['main_image'] && element?.['main_image'] != "" ? modifyImageUrl(element?.['main_image']) : Noimage}
                    alt='productImages'
                    key={element?.['main_image'] + 'Thumbnail' + Math.random()}
                    size='medium'
                    className='custom-linking-lazy__thumbnail'
                />
            </> : element['main_image']
            element['action'] = <><Button size='slim' variant='primary' loading={false} onClick={() => handleLinkModal(data, element['source_product_id'])}>{t("Link")}</Button></>
            // if (element?.matchedwith) element['closeMatch'] = <Badge tone={element.matchedwith == "sku" ? "attention" : "success"}>{element?.matchedwith.charAt(0).toUpperCase() + element?.matchedwith.slice(1)}</Badge>
            element['titleRender'] = <BlockStack>
                <Text as={'h1'}>{element['title']}</Text>
                {element?.matchedwith ? <div className={element.matchedwith == "sku" ? 'customSpanSKU' : 'customSpanBarcode'}><Badge tone={element.matchedwith == "sku" ? "attention" : "success"}>{t(element?.matchedwith.charAt(0).toUpperCase() + element?.matchedwith.slice(1))}</Badge></div> : <></>}
            </BlockStack>
            tempImg.push(element);
        });
        setmatchesFoundModalData(tempImg);
        setamazonData(data)
    }

    const getUnmatchedShopifyProducts = async (searchParams: any = '') => {
        let tempImg: any[] = [];
        let data: any = {}
        data = {
            ...necessaryDetails,
            'activePage': 1,
            'count': 50,
        }

        if (searchParams != "") {
            let filters: any = {};
            filters = {
                'or_filter': { 'title': { "3": searchParams }, 'sku': { "3": searchParams } }
            }
            data = Object.assign({ ...data }, filters);
        }

        setSelectManualGridLoading(true);

        await props.di.POST(`amazon/product/getVariants`, data).then(val => {
            if (val?.success && val?.data) {
                val.data.forEach((element: any) => {
                    // element['main_image'] = <img width={"60px"} height={"60px"} src={element?.['main_image'] != "" ? element?.['main_image'] : Noimage} />;
                    element['main_image'] = <LazyThumbnail
                        src={element?.['main_image'] && element?.['main_image'] != "" ? modifyImageUrl(element?.['main_image']) : Noimage}
                        alt='productImages'
                        key={element?.['main_image'] + 'Thumbnail' + Math.random()}
                        size='medium'
                        className='custom-linking-lazy__thumbnail'
                    />
                    element['action'] = <><Button size='slim' variant='primary' loading={false} onClick={() => handleLinkModal(element, element['source_product_id'], false)}>{t("Link")}</Button></>
                    tempImg.push(element)
                })
                if (searchParams != "") {
                    setmatchesFoundModalData(tempImg)
                }
                else {
                    setlinkProductsModalData(tempImg);
                }
                setSelectManualGridLoading(false);
            } else {
                props.error(t(val.error) ?? t("Request unsuccessful"));
            }
        });
    };

    const renderStatusOfProduct = (status: string) => {
        if (status === "Active") {
            return (<Badge tone="success">{t(status)}</Badge>);
        }
        else if (status === "Incomplete") {
            return (<Badge tone="warning">{t(status)}</Badge>)
        }
        return (<Badge tone="critical">{t(status)}</Badge>);
    }

    const renderSelectManualHeader1 = (val: any) => {
        let modaldata: JSX.Element = <></>;
        modaldata = <div className="custom-productlinking">
            <BlockStack gap='800'>
                <Text as='h3' variant='headingSm'>{t("AMAZON PRODUCT")}</Text>
                <InlineStack gap='400'>
                    <InlineStack wrap={false} gap='400'>
                        {/* <img src={val?.['image-url'] ?? Noimage} height="60px" width={"60px"} /> */}
                        <LazyThumbnail
                            src={val?.['image-url'] && val?.['image-url'] != "" ? modifyImageUrl(val?.['image-url']) : Noimage}
                            alt='productImages'
                            key={val?.['image-url'] + 'Thumbnail' + Math.random()}
                            size='medium'
                            className='custom-linking-lazy__thumbnail'
                        />
                        <BlockStack gap='100'>
                            <div style={{ maxWidth: "200px" }}>
                                {val?.['item-name'].length > 25 ?
                                    <Tooltip content={val['item-name']}>
                                        <Text as='p' tone="subdued">{val['item-name'].substring(0, 25)}...</Text>
                                    </Tooltip>
                                    :
                                    <Text as='p' tone="subdued">{val['item-name']}</Text>
                                }
                            </div>
                            <div>{renderStatusOfProduct(val?.['status'])}</div>
                        </BlockStack>
                    </InlineStack>
                    <div>
                        <InlineStack gap='200'>
                            <Text as='p'>{t("Seller SKU")}:</Text>
                            <Text as='p' tone="subdued">{val?.['seller-sku']}</Text>
                        </InlineStack>
                        <InlineStack gap='200'>
                            <Text as='p'>{t("Barcode")}:</Text>
                            <Text as='p' tone="subdued">{val?.['product-id']}</Text>
                        </InlineStack>
                        <Link url={myContext.viewOnAmazon(val?.['asin1'])} target='_blank' removeUnderline>{t("View On Amazon")}</Link>
                        <div>
                            {val?.['type'] === "variation" ? <Badge tone="info">{t("Parent")}</Badge> : null}
                        </div>
                    </div>
                </InlineStack>
            </BlockStack>
        </div>;
        // setFinalData((prevState) => ({ ...prevState, "_id": val._id.$oid, "image-url": val['image-url'], "seller-sku": val['seller-sku'] }));
        setSelectManualHeader(modaldata);
    }

    const renderSelectedProduct = (obj: any) => {
        let dataToLink: any = [];
        dataToLink.push({
            key: "1",
            // image: <img height={"60px"} width={"60px"} src={obj?.["main_image"] && obj["main_image"] != "" ? obj["main_image"] : Noimage} />,
            image: <LazyThumbnail
                src={obj?.["main_image"] && obj["main_image"] != "" ? modifyImageUrl(obj["main_image"]) : Noimage}
                alt='productImages'
                key={obj?.["main_image"] + 'Thumbnail' + Math.random()}
                size='medium'
                className='custom-linking-lazy__thumbnail'
            />,
            title:
                <BlockStack gap='100'>
                    {obj?.['title'].length > 25 ?
                        <Tooltip content={obj['title']}>
                            <Text as='p' tone="subdued">{obj['title'].substring(0, 25)}...</Text>
                        </Tooltip>
                        :
                        <Text as='p' tone="subdued">{obj['title']}</Text>
                    }
                    <Link url={myContext.viewOnShopify(obj?.['container_id'])} removeUnderline target='_blank'>
                        {t("View on Shopify")}
                    </Link>
                </BlockStack>,
            sku: <Text as='p' tone="subdued">{obj?.['sku'] ?? "-"}</Text>,
            barcode: <Text as='p' tone="subdued">{obj?.['barcode'] ?? '-'}</Text>,
        });
        setFinalData((prevState) => ({ ...prevState, "source_product_id": obj?.['source_product_id'] }));
        setSelectManualGridData2(dataToLink);
    }

    const handleSelectManual2 = (obj: any) => {
        setSelectManualModal1(false);
        setSelectManualModal2(true);
        renderSelectedProduct(obj);
    }

    const renderUnmatchedShopifyProducts = () => {
        let modifiedRows: any = [];
        // let variantShopifyProducts: any = shopifyProducts.filter((obj: any) => obj?.type == 'variation');
        // let simpleShopifyProducts: any = shopifyProducts.filter((obj: any) => obj?.type == 'simple');
        // let updatedShopifyProducts: any = [];

        // if (isVariant) updatedShopifyProducts = variantShopifyProducts
        // else updatedShopifyProducts = simpleShopifyProducts
        shopifyProducts.length > 0 && shopifyProducts.map((obj: any, index: any) => {
            modifiedRows.push({
                key: index,
                // image: <img height={"60px"} width={"60px"} src={obj?.["main_image"] && obj?.["main_image"] != "" ? obj?.["main_image"] : Noimage} />,
                image: <LazyThumbnail
                    src={obj?.["main_image"] && obj["main_image"] != "" ? modifyImageUrl(obj["main_image"]) : Noimage}
                    alt='productImages'
                    key={obj?.["main_image"] + 'Thumbnail' + Math.random()}
                    size='medium'
                    className='custom-linking-lazy__thumbnail'
                />,
                title: <BlockStack gap='100'>
                    {obj?.['title'].length > 25 ?
                        <Tooltip content={obj['title']}>
                            <Text as='p' tone="subdued">{obj['title'].substring(0, 25)}...</Text>
                        </Tooltip>
                        :
                        <Text as='p' tone="subdued">{obj['title']}</Text>
                    }
                    <Link url={myContext.viewOnShopify(obj?.['container_id'])} removeUnderline target='_blank'>
                        {t("View on Shopify")}
                    </Link>
                </BlockStack>,
                sku: <Text as='p' tone="subdued">{obj?.['sku'] ?? "-"}</Text>,
                barcode: <Text as='p' tone="subdued">{obj?.['barcode'] ?? '-'}</Text>,
                action: <Button id='' variant='primary' onClick={() => {
                    handleSelectManual2(obj)
                }}>{t('Link')}</Button>
            })
        });
        setSelectManualGridData1(modifiedRows);
    }

    useEffect(() => {
        renderUnmatchedShopifyProducts();
    }, [shopifyProducts]);

    const renderSelectManualGrid1 = async (type: string) => {
        setSelectManualGridLoading(true);
        let data: any = {}
        data = {
            ...necessaryDetails,
            'activePage': 1,
            'count': 50,
            'type': type == "variation" || variation ? "variation" : "simple"
        }
        if (shopifySearch != "") {
            let filters: any = {};
            filters = {
                'or_filter': { 'title': { "3": shopifySearch }, 'sku': { "3": shopifySearch } }
            }
            data = Object.assign({ ...data }, filters);
        }
        await props.di.POST(`amazon/product/getVariants`, data).then(val => {
            if (val?.success && val?.data) {
                setShopifyProducts(val.data);
            } else {
                props.error(t(val.error) ?? t("Request unsuccessful"));
            }
            setSelectManualGridLoading(false);
        })
    }

    function handleSelectManual1(data: any) {
        renderSelectManualHeader1(data);
        renderSelectManualGrid1(data?.type ?? 'simple');
        setSelectManualModal1(true);
    }

    function handleShopifySearch(e: any) {
        setShopifySearch(e)
        setSelectManualGridLoading(true);
        getUnmatchedShopifyProducts(e)
        let temp: any[] = [];
        linkProductsModalData.forEach((ele) => {
            let regex = new RegExp(e, 'gi');
            if (regex.test(ele['sku']) || regex.test(ele['title'])) {
                temp.push(ele);
            }
            setSelectManualGridLoading(false);
        });
        setSearchTextField(e);
        setlinkProductsModalData(temp)
    }

    function closeManualModal() {
        setshowLinkProductsModal(false);
        setShopifySearch('')
        setmatchesFoundModalData([]);
    }

    const columns: any = [
        {
            title: <Text variant="headingXs" as="h6" tone="subdued" fontWeight="medium">{t("Amazon")}</Text>,
            dataIndex: "amazon",
            key: "amazon",
            width: 400,
        },
        {
            title: <Text variant="headingXs" as="h6" tone="subdued" fontWeight="medium">{t("Shopify")}</Text>,
            dataIndex: "shopify",
            key: "shopify",
            width: 400,
        },
        {
            title: <Text variant="headingXs" as="h6" tone="subdued" fontWeight="medium">{t("Action")}</Text>,
            key: "action",
            width: 100,
            align: "center",
            dataIndex: "action",
        }
    ];

    const handleTotalpage = (totalProducts: number) => {
        let pages = 0;
        if (totalProducts % count === 0) {
            pages = totalProducts / count;
        } else {
            pages = Math.trunc(totalProducts / count) + 1;
        }
        setTotalPage(pages);
    };

    const getCloseMatchListing = () => {
        if (!tableLoading) {
            setTableLoading(true);
        }
        let data: any = {};
        data = {
            ...necessaryDetails,
            'data': {
                'matched': "closeMatch",
                'activePage': currentPage,
                'count': count,
            },
            'fulfillment-channel': myContext.fulfillmentType == 'FBM' ? 'DEFAULT' : 'FBA',
        }
        if (firstRender && props.location.state?.sku) {
            data = { ...data, filter: { 'seller-sku': { '1': props.location.state.sku } } }
        } else if (inputValue != "") {
            let filters: any = {};
            filters = {
                'or_filter': { 'item-name': { "3": inputValue }, 'seller-sku': { "3": inputValue }, 'product-id': { "3": inputValue } }
            }
            data = Object.assign({ ...data }, filters);
        }
        firstRender && setfirstRender(false)
        props.di.POST(`amazon/product/getAmazonListing`, data).then(val => {
            if (val.success) {
                myContext.getListingCount('close_matched');
                myContext.renderListingCount({ 'close_matched': val?.total_products });
                handleTotalpage(val?.total_products);
            } else {
                props.error(t(val.message) ?? t("Request unsuccessful"));
            }
            setProducts(val.response);

            setTableLoading(false);
        })
    };

    var debounceShopify = debounce(() => { getUnmatchedShopifyProducts(); }, 1000);

    useEffect(() => {
        return () => {
            debounceShopify.cancel();
        };
    }, [debounceShopify]);

    var debounceListing = debounce(() => getCloseMatchListing(), 1000);

    useEffect(() => {
        if (props?.location?.state?.from == "transferOrder") {
            setInputValue(props?.location?.state?.sku)
        }
        getCloseMatchListing();

        // }, [currentPage, props.fulfillmentType]);
    }, [currentPage, myContext.fulfillmentType]);

    useEffect(() => {
        debounceListing();
    }, [inputValue])

    useEffect(() => {
        return () => {
            debounceListing.cancel();
        };
    }, [debounceListing]);

    // useEffect(() => {
    //     getUnmatchedShopifyProducts()
    // }, [])

    const handleApprove = (element: any = '', i: any = '') => {
        setTableLoading(true);
        let sourceProductId = linkModalData[0]?.['source_product_id']

        let data: any = {};
        data = {
            ...necessaryDetails,
            'data': {
                _id: parentId.$oid,
                source_product_id: sourceProductId,
            }
        };
        setApproveLoading({ ...approveLoading, [i]: true });

        props.di.POST(`amazon/product/manualMap`, data).then(val => {
            if (val.success) {
                if (props.location.state.from == 'transferOrder') {
                    props.history('../transfer-order', { state: props.location.state });
                }
                props.success(t(val.message) ?? t("Request Unsuccessful"));
                setHasApproved(true);
                clearTimeout(timer);
                renderSummaryOfTable('approve', element);
                getCloseMatchListing();
            } else {
                props.error(t(val.message) ?? t("Request unsuccessful"));
            }
            setmatchesFoundModalData([])
            setTableLoading(false);
            setApproveLoading({ ...approveLoading, [i]: false });
        });
        setshowLinkModal(false)
    }

    const handleApproveAll = () => {
        let productRows: any = [];
        let data: any = {};
        products.forEach((element: any) => {
            productRows.push({
                _id: element._id.$oid,
                source_product_id: element?.["closeMatchedProduct"][0]?.["source_product_id"],
            });
        });
        data = {
            ...necessaryDetails,
            'data': {
                products: productRows,
            }
        };
        setButtonLoading({ ...buttonLoading, approveAll: true });
        props.di.POST(`amazon/product/approveAllMap`, data).then(val => {
            if (val.success) {
                props.success(t(val.message) ?? t("Request Unsuccessful"));
                setHasApproved(false);
                handleModal();
                getCloseMatchListing();
            } else {
                props.error(t(val.message) ?? t("Request unsuccessful"));
            }
            setButtonLoading({ ...buttonLoading, approveAll: false });
        });
    }

    const handleUndoApprove = (element: any) => {
        let data: any = {};
        data = {
            ...necessaryDetails,
            'data': {
                _id: element._id.$oid,
                source_product_id: element?.["closeMatchedProduct"]?.["source_product_id"],
            }
        };
        setButtonLoading({ ...buttonLoading, undoApprove: true });
        setTableLoading(true);
        props.di.POST(`amazon/product/manualUnmap`, data).then(val => {
            if (val.success) {
                props.di.POST(`amazon/product/manualCloseMatch`, data).then(val1 => {
                    if (val1.success) {
                        props.success(t(val1.message) ?? t("Request Unsuccessful"));
                        setSummaryOfTable(<></>);
                        setHasApproved(false);
                        getCloseMatchListing();
                    } else {
                        props.error(t(val1.message) ?? t("Request unsuccessful"));
                        setTableLoading(true);
                    }
                    setButtonLoading({ ...buttonLoading, undoApprove: false });
                });
            } else {
                props.error(t(val.message) ?? t("Request unsuccessful"));
                setButtonLoading({ ...buttonLoading, undoApprove: false });
                setTableLoading(false);
            }
        });
    };

    useEffect(() => {
        renderCloseMatchListing();
    }, [products, approveLoading, buttonLoading, tableLoading]);

    const button: any = <InlineStack gap="100" align='center' blockAlign='center'>
        <img src={AmazonBtnIcon} height="14px" width="14px" />
        <Icon source={ExternalMinor} tone="info" />
    </InlineStack>;

    const button2: any = <InlineStack gap="100" blockAlign='center'>
        <img src={ShopifyBtnIcon} />
        <Icon source={ExternalMinor} tone="info" />
    </InlineStack>;

    const renderCloseMatchListing = () => {
        let closeMatchData: any = [];
        if (products?.length > 0) {
            products.forEach((val: any, i) => {
                let current_shop_currency: any = amazon_regions.filter((value: any) => value?.currency == props?.redux?.current?.source?.currency)?.[0];
                closeMatchData.push(
                    {
                        key: i.toString(),
                        amazon:
                            <InlineStack gap='300' wrap={false}>
                                {/* <img width={"60px"} height={"60px"} src={val?.['image-url'] && val?.['image-url'] != "" ? val?.['image-url'] : Noimage} /> */}
                                <LazyThumbnail
                                    src={val?.['image-url'] && val?.['image-url'] != "" ? modifyImageUrl(val?.['image-url']) : Noimage}
                                    alt='productImages'
                                    key={val?.['image-url'] + 'Thumbnail' + Math.random()}
                                    size='medium'
                                    className='custom-linking-lazy__thumbnail'
                                />,
                                <BlockStack gap='100'>
                                    <div style={{ minWidth: "200px" }}>
                                        {val?.['item-name'].length > 100 ?
                                            <Tooltip content={val['item-name']}>
                                                <Text as='h3' variant='headingSm'>{val['item-name'].substring(0, 100)}...</Text>
                                            </Tooltip>
                                            :
                                            <Text as='h3' variant='headingSm'>{val['item-name']}</Text>
                                        }
                                    </div>
                                    <InlineStack gap='100'>
                                        <Text as="p" fontWeight="semibold">SKU:</Text>
                                        <Text as='span' tone="subdued">{val?.['seller-sku']}</Text>
                                    </InlineStack>
                                    <InlineStack gap='100'>
                                        <Text as="p" fontWeight="semibold">Barcode:</Text>
                                        <Text as='p' tone="subdued">{val?.['product-id']}</Text>
                                    </InlineStack>
                                    <InlineStack gap='300' wrap={false} blockAlign='center'>
                                        <div>
                                            <Button url={myContext.viewOnAmazon(val?.['asin1'])} target='_blank' size='slim'>{button}</Button>
                                        </div>
                                        <ViewMoreInfo val={val} renderStatusOfProduct={renderStatusOfProduct} current_shop_currency={current_shop_currency} />
                                    </InlineStack>
                                    {/* <div>
                                        {val?.['type'] === "variation" ? <Badge tone="info">Parent</Badge> : null}
                                    </div> */}
                                </BlockStack>
                            </InlineStack>,
                        shopify: val?.['closeMatchedProduct']?.length == 1 ?
                            <InlineStack gap='300'>
                                {/* <img width={"60px"} height={"60px"} src={val?.['matchedProduct']?.['main_image'] && val?.['matchedProduct']?.['main_image'] != "" ? val?.['matchedProduct']?.['main_image'] : Noimage} /> */}
                                <LazyThumbnail
                                    src={val?.['matchedProduct']?.['main_image'] && val?.['matchedProduct']?.['main_image'] != "" ? modifyImageUrl(val?.['matchedProduct']?.['main_image']) : Noimage}
                                    alt='productImages'
                                    key={val?.['matchedProduct']?.['main_image'] + 'Thumbnail' + Math.random()}
                                    size='medium'
                                    className='custom-linking-lazy__thumbnail'
                                />,
                                <BlockStack gap='100'>
                                    <div style={{ minWidth: "200px" }}>
                                        {val?.['closeMatchedProduct']?.[0]?.['title'].length > 25 ?
                                            <Tooltip content={val?.['closeMatchedProduct']?.[0]?.['title']}>
                                                <Text as='h3' variant='headingSm'>{val?.['closeMatchedProduct']?.[0]?.['title'].substring(0, 100)}...</Text>
                                            </Tooltip>
                                            :
                                            <Text as='h3' variant='headingSm'>{val?.['closeMatchedProduct']?.[0]?.['title']}</Text>
                                        }
                                    </div>
                                    <InlineStack gap='100'>
                                        <Text as="p" fontWeight="regular">Seller SKU:</Text>
                                        <Text as='p' tone="subdued">{val?.['closeMatchedProduct']?.[0]?.['sku']}</Text>
                                    </InlineStack>
                                    <InlineStack gap='100'>
                                        <Text as="p" fontWeight="regular">Barcode:</Text>
                                        <Text as='span' tone="subdued">{val?.['closeMatchedProduct']?.[0]?.['barcode']}</Text>
                                    </InlineStack>
                                    <div>
                                        <Button url={myContext.viewOnShopify(val?.['closeMatchedProduct']?.[0]?.['container_id'])} target='_blank'>{button2}</Button>
                                    </div>
                                </BlockStack>
                            </InlineStack >
                            :
                            <>
                                <Link onClick={() => handleMatchesFoundModal(val)} removeUnderline>{val?.['closeMatchedProduct']?.length} {t("Matches Found")}</Link>
                                <Text as="p" fontWeight="regular">
                                    {t("Select the closest match")}
                                </Text>
                            </>,
                        action: <>
                            <InlineStack gap='200' align="center">
                                {/* <Button size='slim' variant='primary'disabled={val?.['closeMatchedProduct']?.length == 1 ? false : true} loading={approveLoading[i]} onClick={() => handleLinkModal(val)}>Link</Button> */}
                                <Button size='slim' loading={selectManualLoading} onClick={() => handleSelectManual1(val)} >{t("Select Manually")}</Button>
                            </InlineStack>
                        </>
                    },
                )
            })
        }
        setData(closeMatchData);
    }

    const renderSummaryOfTable = (type: string, data: any) => {
        let summary: JSX.Element = <Table.Summary fixed="top">
            <Table.Summary.Row>
                <Table.Summary.Cell index={0} colSpan={3}>
                    <InlineStack align="space-between" gap='100' blockAlign="center">
                        <InlineStack gap='200' blockAlign="center">
                            {/* <Thumbnail source={data["image-url"]} size={"medium"} alt="" /> */}
                            <LazyThumbnail
                                src={data["image-url"] ? modifyImageUrl(data["image-url"]) : Noimage}
                                alt='productImages'
                                key={data["image-url"] + 'Thumbnail' + Math.random()}
                                size='medium'
                                className='custom-linking-lazy__thumbnail'
                            />
                            <Text as='span' fontWeight="semibold">
                                {t("Linking was successful. You can view the linked product in the Linked Section.")}&nbsp;
                                <Button variant='plain' tone='critical' loading={buttonLoading.undoApprove} onClick={() => { handleUndoApprove(data) }}>
                                    {t("Undo Linking")}
                                </Button>&nbsp;or&nbsp;
                                <Button variant='plain' onClick={() => { myContext.viewProductValue(2, data['seller-sku']) }}>
                                    {t("View Linked Product")}.
                                </Button>
                            </Text>
                        </InlineStack>
                    </InlineStack>
                </Table.Summary.Cell>
            </Table.Summary.Row>
        </Table.Summary>
        setSummaryOfTable(summary);
        timer = setTimeout(() => {
            setHasApproved(false);
            setSummaryOfTable(<></>);
        }, 30000);
    }

    const updateText = useCallback((value: any) => { setCurrentPage(1); setInputValue(value) }, []);
    const handleClearButtonClick = useCallback(() => updateText(''), []);

    const handleModal = () => {
        setModal(!modal);
    }

    const handlePreviousPagination = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
        setHasPageChanged(!hasPageChanged);
    }

    const handleNextPagination = () => {
        if (currentPage !== totalPage) setCurrentPage(currentPage + 1);
        setHasPageChanged(!hasPageChanged);
    }

    const selectManualHeadings1: any = [
        { title: <Text variant="headingSm" as="h6">{t("Image")}</Text>, dataIndex: "image", width: 100 },
        { title: <Text variant="headingSm" as="h6">{t("Product Title")}</Text>, dataIndex: "title", width: 200 },
        { title: <Text variant="headingSm" as="h6">{t("Shopify SKU")}</Text>, dataIndex: "sku", width: 200 },
        { title: <Text variant="headingSm" as="h6">{t("Barcode")}</Text>, dataIndex: "barcode", width: 200 },
        { title: <Text variant="headingSm" as="h6">{t("Action")}</Text>, dataIndex: "action", width: 100, align: "center", },
    ];

    const headings2: any = [
        { title: <Text variant="headingSm" as="h6">{t("Image")}</Text>, dataIndex: "image", width: 100 },
        { title: <Text variant="headingSm" as="h6">{t("Product Title")}</Text>, dataIndex: "title", width: 200 },
        { title: <Text variant="headingSm" as="h6">{t("Shopify SKU")}</Text>, dataIndex: "sku", width: 200 },
        { title: <Text variant="headingSm" as="h6">{t("Barcode")}</Text>, dataIndex: "barcode", width: 200 },
    ];

    const handleManualMap = () => {
        if (finalData._id !== "" && finalData?.["source_product_id"] !== "") {
            let data: any = {};
            data = {
                ...necessaryDetails,
                'data': {
                    _id: finalData._id,
                    source_product_id: finalData?.["source_product_id"],
                }
            };
            // setModalLinkButton(true);
            // setLoading(true)
            props.di.POST(`amazon/product/manualMap`, data).then(val => {
                if (val.success) {
                    if (props?.location?.state?.from == 'transferOrder') {
                        props.history('../transfer-order', { state: props?.location?.state });
                    }
                    props.success(t(val.message));
                    setSelectManualModal1(false);
                    setSelectManualModal2(false);
                    setHasApproved(true);
                    // getUnlinkedListing(false);
                    clearTimeout(timer);
                    renderSummaryOfTable('approve', finalData);
                    getUnmatchedShopifyProducts();
                } else {
                    props.error(t(val.message) ?? t("Request unsuccessful"));
                }
                // setModalLinkButton(false);
            });
        } else {
            props.error(t("Kindly select valid product data"));
        }
    }

    return (
        <div>
            <BlockStack gap='200'>
                <TextField
                    onChange={updateText}
                    value={inputValue}
                    prefix={<Icon source={SearchMinor} tone="base" />}
                    placeholder={t("Search by Amazon Title, Barcode, or SKU")}
                    onClearButtonClick={handleClearButtonClick}
                    clearButton={true}
                    label=""
                    autoComplete="off"
                />

                <div className={"custom-productlinking approved"}>
                    <Card padding="0">
                        {
                            !tableLoading ?
                                <Table sticky summary={() => summaryOfTable} columns={columns} dataSource={data} scroll={{ x: 700 }} pagination={false} loading={tableLoading} size='middle' />
                                : <CloseMatchSkeleton />
                        }
                    </Card>
                </div>
                {totalPage > 0 &&
                    <InlineStack align="center">
                        <Pagination
                            label={`${currentPage} / ${totalPage}`}
                            hasPrevious={currentPage <= 1 ? false : true}
                            onPrevious={() => {
                                handlePreviousPagination()
                            }}
                            hasNext={currentPage === totalPage ? false : true}
                            onNext={() => {
                                handleNextPagination()
                            }}
                        />
                    </InlineStack>
                }
            </BlockStack>

            {/* Modal for Aprove All */}
            <Modal
                open={modal}
                onClose={handleModal}
                title={t("Link Products")}
                primaryAction={{
                    loading: buttonLoading.modalButton,
                    content: t('Yes'),
                    onAction: handleApproveAll,
                }}
                secondaryActions={[
                    {
                        content: t('Cancel'),
                        onAction: handleModal,
                    },
                ]}
            >
                <Modal.Section>
                    <Text as="p" fontWeight="regular">
                        {t("Are you sure you want to proceed for Approve All Close Match?")}
                    </Text>
                </Modal.Section>
            </Modal>

            <Modal
                size='large'
                open={showLinkModal}
                onClose={handleCloseLinkModal}
                title={t("Link")}
                primaryAction={
                    {
                        content: t('Confirm'),
                        onAction: () => handleApprove(),
                        loading: false
                    }
                }
                secondaryActions={[
                    {
                        content: t('Back'),
                        onAction: handleCloseLinkModal,
                    },
                ]}
            >
                <Modal.Section>
                    <BlockStack gap='500'>
                        <BlockStack gap='800'>
                            <Text as='h3' variant='headingSm'>{t("Amazon product")}</Text>
                            <InlineStack gap='400'>
                                <InlineStack gap='400' wrap={false}>
                                    {/* <img src={amazonData?.['image-url'] || Noimage} height="60px" width={"60px"} /> */}
                                    <LazyThumbnail
                                        src={amazonData?.['image-url'] && amazonData?.['image-url'] != "" ? modifyImageUrl(amazonData?.['image-url']) : Noimage}
                                        alt='productImages'
                                        key={amazonData?.['image-url'] + 'Thumbnail' + Math.random()}
                                        size='medium'
                                        className='custom-linking-lazy__thumbnail'
                                    />
                                    <BlockStack gap='100'>
                                        <div style={{ maxWidth: "200px" }}>
                                            {amazonData?.['item-name']?.length > 25 ?
                                                <Tooltip content={amazonData['item-name']}>
                                                    <Text as='p' tone="subdued">{amazonData['item-name'].substring(0, 25)}...</Text>
                                                </Tooltip>
                                                :
                                                <Text as='span' tone="subdued">{amazonData['item-name']}</Text>
                                            }
                                        </div>
                                        {(amazonData?.['status'])}
                                    </BlockStack>
                                </InlineStack>
                                <div>
                                    <InlineStack gap='200'>
                                        <Text as='p'>{t("Seller SKU")}:</Text>
                                        <Text as='p' tone="subdued">{amazonData?.['seller-sku']}</Text>
                                    </InlineStack>
                                    <InlineStack gap='200'>
                                        <Text as='p'>{t("Barcode")}:</Text>
                                        <Text as='p' tone="subdued">{amazonData?.['product-id']}</Text>
                                    </InlineStack>
                                    <InlineStack gap='200'>
                                        <Link url={myContext.viewOnAmazon(amazonData?.['asin1'])} target='_blank' removeUnderline>{t("View On Amazon")}</Link>
                                    </InlineStack>
                                </div>
                            </InlineStack>
                        </BlockStack>
                        <Table columns={linkHeadings} dataSource={linkModalData} scroll={{ x: 800 }} pagination={false} size="middle" />
                        <Text as='p' fontWeight="semibold">{t("Are you sure you want to Link the Product?")}</Text>
                    </BlockStack>
                </Modal.Section>
            </Modal>

            <Modal
                size='large'
                open={showLinkProductsModal}
                onClose={closeManualModal}
                title={t("Link Products")}
                secondaryActions={[
                    {
                        content: t('Cancel'),
                        onAction: closeManualModal,
                    },
                ]}
            >
                <Modal.Section>
                    <BlockStack gap='400'>
                        <BlockStack gap='800'>
                            <Text as='h3' variant='headingSm'>{t("Amazon product")}</Text>
                            <InlineStack gap='400'>
                                <InlineStack gap='400' wrap={false}>
                                    {/* <img src={amazonData?.['image-url'] || Noimage} height="60px" width={"60px"} /> */}
                                    <LazyThumbnail
                                        src={amazonData?.['image-url'] && amazonData?.['image-url'] != "" ? modifyImageUrl(amazonData?.['image-url']) : Noimage}
                                        alt='productImages'
                                        key={amazonData?.['image-url'] + 'Thumbnail' + Math.random()}
                                        size='medium'
                                        className='custom-linking-lazy__thumbnail'
                                    />
                                    <BlockStack gap='100'>
                                        <div style={{ maxWidth: "200px" }}>
                                            {amazonData?.['item-name']?.length > 25 ?
                                                <Tooltip content={amazonData['item-name']}>
                                                    <Text as='span' tone="subdued">{amazonData['item-name'].substring(0, 25)}...</Text>
                                                </Tooltip>
                                                :
                                                <Text as='span' tone="subdued">{amazonData['item-name']}</Text>
                                            }
                                        </div>
                                        {t(amazonData?.['status'])}
                                    </BlockStack>
                                </InlineStack>
                                <div>
                                    <InlineStack gap='200'>
                                        <Text as='span'>{t("Seller SKU")}:</Text>
                                        <Text as='span' tone="subdued">{amazonData?.['seller-sku']}</Text>
                                    </InlineStack>
                                    <InlineStack gap='200'>
                                        <Text as='span'>{t("Barcode")}:</Text>
                                        <Text as='span' tone="subdued">{amazonData?.['product-id']}</Text>
                                    </InlineStack>
                                    <InlineStack gap='200'>
                                        <Link url={myContext.viewOnAmazon(amazonData?.['asin1'])} target='_blank' removeUnderline>{t("View On Amazon")}</Link>
                                    </InlineStack>
                                </div>
                            </InlineStack>
                        </BlockStack>
                        <TextField onChange={handleShopifySearch} value={shopifySearch} prefix={<Icon source={SearchMinor} tone="base" />}
                            label=""
                            autoComplete=''
                            placeholder={t("Search by Shopify Title or SKU")}
                        />
                        <Table columns={linkProductsHeadings} dataSource={matchesFoundModalData.length ? matchesFoundModalData : linkProductsModalData} scroll={{ x: 800 }} pagination={false} size='middle' />
                    </BlockStack>
                </Modal.Section>
            </Modal>

            <Modal
                size='large'
                open={selectManaualModal1}
                onClose={() => { setSelectManualModal1(false) }}
                title={t("Link Products Manually")}
                secondaryActions={[
                    {
                        content: t('Cancel'),
                        onAction: () => { setSelectManualModal1(false) },
                    },
                ]}
            >
                <Modal.Section>
                    <div id='failedOrder_tour_8'>
                        <BlockStack gap='500'>
                            {selectManualHeader1}
                            <TextField onChange={handleShopifySearch} value={shopifySearch} prefix={<Icon source={SearchMinor} tone="base" />}
                                label=""
                                autoComplete=''
                                placeholder={t("Search by Shopify Title or SKU")}
                            />
                            <Table loading={selectManualGridLoading} columns={selectManualHeadings1} dataSource={selectManualGridData1} scroll={{ x: 800 }} pagination={false} />
                        </BlockStack>
                    </div>
                </Modal.Section>
            </Modal>

            <Modal
                size='large'
                open={selectManaualModal2}
                onClose={() => { setSelectManualModal2(false); setSelectManualModal1(true); }}
                title={t("Link")}
                primaryAction={
                    {
                        content: t('Confirm'),
                        onAction: () => { handleManualMap() },
                        // loading: modalLinkButton,
                    }
                }
                secondaryActions={[
                    {
                        content: t('Back'),
                        onAction: () => { setSelectManualModal2(false); setSelectManualModal1(true); }
                    },
                ]}
            >
                <Modal.Section>
                    <BlockStack gap='500'>
                        <Table columns={headings2} dataSource={selectManualGridData2} scroll={{ x: 800 }} pagination={false} />
                        <Text as='p' fontWeight="semibold">{t("Are you sure you want to Link the Product?")}</Text>
                    </BlockStack>
                </Modal.Section>
            </Modal>
        </div >
    )
}
export default DI(CloseMatch);